import React from 'react'
import {
    StyledBreachContainer,
    StyledPremiumIcon,
    StyledHeading,
    StyledPremiumLabel,
    StyledCTA,
    StyledSubscriptionContainer,
    StyledSubscription,
    StyledSubscriptionHeading,
    StyledSubscriptionPrice,
    StyledSubscriptionWrapper,
    StyledSubscribeButton,
    StyledLoginContainer,
    StyledParagraph,
    StyledImageNewsPaper,
    StyledImageEveryDayDigital,
    StyledBreachFooter,
    StyledHR,
    StyledOutlineAnchor,
    StyledContactDetails,
    StyledBreachFooterText,
} from './BreachNotification.styled'
import { BreachEvent } from 'common/events/breachEventTypes'
import { createLinkClickEvent } from '../createLinkClickHandler'
import { AuthenticationProvider } from 'component-library/user-registration/authentication/AuthenticationProvider'
import { FeatureToggle } from 'component-library/feature-toggling/Toggle/Toggle'

const everyDayDigitalImage = require('../images/everyday_digital.png')
const everyDayNewspaperImage = require('../images/everyday_digital_newspaper.png')

export interface Props {
    Login: React.ReactType
    isLoggedIn: boolean | undefined
    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export function BreachNotification({
    isLoggedIn,
    Login,
    articleId,
    breachDeal,
    breachCreativeName,
    onEvent,
}: Props) {
    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ createBreachSubscribeClickEvent }) => (
                <StyledBreachContainer data-testid="BreachScreen">
                    <StyledHeading>Subscribe to the West Australian</StyledHeading>
                    <StyledPremiumLabel>
                        <StyledPremiumIcon hasContainer /> This article is available to subscribers
                        who have digital access included in their subscription.
                    </StyledPremiumLabel>
                    {!isLoggedIn && (
                        <StyledLoginContainer>
                            Already a Subscriber? <Login />
                        </StyledLoginContainer>
                    )}
                    <StyledHR />
                    <StyledCTA>
                        Subscribe now and get unlimited access to award-winning journalism from
                        Western Australia’s biggest newsroom and across the state.
                    </StyledCTA>
                    <StyledSubscriptionContainer>
                        <StyledSubscription className={'BreachNotification_DigitalSubscription'}>
                            <StyledImageEveryDayDigital src={everyDayDigitalImage} alt="" />
                            <StyledSubscriptionWrapper>
                                <StyledSubscriptionHeading>
                                    Everyday Digital{' '}
                                    <StyledSubscriptionPrice>$1.00 per day</StyledSubscriptionPrice>
                                </StyledSubscriptionHeading>
                                <FeatureToggle
                                    feature={'simple-digital-subscription-form'}
                                    on={() => (
                                        <StyledSubscribeButton
                                            onClick={() => {
                                                createLinkClickEvent(
                                                    breachCreativeName,
                                                    breachDeal,
                                                    onEvent
                                                )()
                                                createBreachSubscribeClickEvent({
                                                    packagePath: 'subscribe/new',
                                                    articleId,
                                                    breachCreativeName,
                                                    breachDeal,
                                                })()
                                            }}
                                        >
                                            Subscribe Now
                                        </StyledSubscribeButton>
                                    )}
                                    off={() => (
                                        <StyledSubscribeButton
                                            onClick={() => {
                                                createLinkClickEvent(
                                                    breachCreativeName,
                                                    breachDeal,
                                                    onEvent
                                                )()
                                                createBreachSubscribeClickEvent({
                                                    packagePath: 'subscribenow/digital',
                                                    articleId,
                                                    breachCreativeName,
                                                    breachDeal,
                                                })()
                                            }}
                                        >
                                            Subscribe Now
                                        </StyledSubscribeButton>
                                    )}
                                />
                                <StyledParagraph>
                                    Enjoy premium digital access to thewest.com.au, our regional
                                    websites, The West app and the digital editions of The West and
                                    The Sunday Times.
                                </StyledParagraph>
                            </StyledSubscriptionWrapper>
                        </StyledSubscription>
                        <StyledSubscription className={'BreachNotification_NewspaperSubscription'}>
                            <StyledImageNewsPaper src={everyDayNewspaperImage} alt="" />
                            <StyledSubscriptionWrapper>
                                <StyledSubscriptionHeading>
                                    Weekend Papers +<br />
                                    Everyday Digital
                                    <StyledSubscriptionPrice>
                                        $9.00 per week
                                    </StyledSubscriptionPrice>
                                </StyledSubscriptionHeading>
                                <StyledSubscribeButton
                                    onClick={() => {
                                        createLinkClickEvent(
                                            breachCreativeName,
                                            breachDeal,
                                            onEvent
                                        )()
                                        createBreachSubscribeClickEvent({
                                            packagePath: 'subscribenow/sat-sun+digital',
                                            articleId,
                                            breachCreativeName,
                                            breachDeal,
                                        })()
                                    }}
                                >
                                    Subscribe Now
                                </StyledSubscribeButton>
                                <StyledParagraph>
                                    Enjoy premium digital access to thewest.com.au, our regional
                                    websites, The West app and the digital editions of The West and
                                    The Sunday Times. Plus, receive the weekend papers home
                                    delivered.
                                </StyledParagraph>
                            </StyledSubscriptionWrapper>
                        </StyledSubscription>
                    </StyledSubscriptionContainer>
                    <StyledBreachFooter>
                        <StyledBreachFooterText>
                            All subscriptions include exclusive subscriber offers, events and
                            giveaways with West Benefits and our subscriber rewards program.
                        </StyledBreachFooterText>

                        <StyledOutlineAnchor
                            onClick={() => {
                                createLinkClickEvent(breachCreativeName, breachDeal, onEvent)()
                                createBreachSubscribeClickEvent({
                                    articleId,
                                    breachCreativeName,
                                    breachDeal,
                                })()
                            }}
                        >
                            View All Subscription Packages
                        </StyledOutlineAnchor>
                        <StyledContactDetails>
                            Need Help? Call <a href="tel:1800 811 855">1800 811 855.</a>
                        </StyledContactDetails>
                    </StyledBreachFooter>
                </StyledBreachContainer>
            )}
        </AuthenticationProvider>
    )
}
